import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminNotificationTemplatesPage } from "./admin-notification-templates-page";
import { AdminManualNotificationPage } from "./admin-manual-notification-page";
import { AdminAnnouncementsPage } from "./admin-announcements-page";
import { DirectMessagePage } from "../shared/direct-message-page";
import { getCurrentUserRole } from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import { useSearchParams } from "react-router-dom";

export function AdminNotificationsPage() {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const sessionId = searchParams.get("sessionId");

    const { data: userRole } = useQuery({
        queryKey: queryKeys.currentUserProfile,
        queryFn: getCurrentUserRole,
    });

    const isAdmin = userRole?.role === "admin";

    if (userId) {
        return <DirectMessagePage userId={userId} />;
    }

    const defaultTab = sessionId || !isAdmin ? "manual" : "templates";

    return (
        <div className="flex flex-col gap-6">
            <div>
                <h1 className="text-3xl font-bold tracking-tight">Benachrichtigungen</h1>
                <p className="text-muted-foreground">
                    {isAdmin
                        ? "Verwalte E-Mail-Vorlagen, sende manuelle Benachrichtigungen und veröffentliche In-App-Benachrichtigungen."
                        : "Sende manuelle Benachrichtigungen an Teilnehmer."}
                </p>
            </div>

            <Tabs defaultValue={defaultTab} className="w-full">
                {isAdmin && (
                    <TabsList className="grid w-full max-w-lg grid-cols-3">
                        <TabsTrigger value="templates">Vorlagen</TabsTrigger>
                        <TabsTrigger value="manual">Nachricht senden</TabsTrigger>
                        <TabsTrigger value="in-app">In-App</TabsTrigger>
                    </TabsList>
                )}
                {isAdmin && (
                    <TabsContent value="templates" className="mt-6">
                        <AdminNotificationTemplatesPage />
                    </TabsContent>
                )}
                <TabsContent value="manual" className={isAdmin ? "mt-6" : ""}>
                    <AdminManualNotificationPage />
                </TabsContent>
                {isAdmin && (
                    <TabsContent value="in-app" className="mt-6">
                        <AdminAnnouncementsPage />
                    </TabsContent>
                )}
            </Tabs>
        </div>
    );
}
